import React, { FC } from 'react';
import './Drawer.scss';
import { Drawer as AntDrawer, DrawerProps } from 'antd';
import { CloseIcon } from '@shared/ui/icons';
import { twMerge } from '@shared/utils/twMerge';

export const Drawer: FC<DrawerProps> = props => {
  return (
    <AntDrawer
      className={twMerge('!mr-[7.5px] !p-[40px] text-black', props.className)}
      classNames={{
        ...props.classNames,
        header: twMerge('', props.classNames?.header),
        content: twMerge('!rounded-modal', props.classNames?.content),
        mask: twMerge('opacity-40', props.classNames?.mask),
        footer: twMerge('', props.classNames?.footer),
      }}
      styles={{ wrapper: { borderRadius: '30px', margin: '24px' } }}
      closeIcon={props.closeIcon && <CloseIcon className="h-[30px] w-3" />}
      {...props}
      title={<h2 className="!text-[24px] leading-10">{props.title}</h2>}
    />
  );
};
